import { AdminNoticeSetting } from "pages/setting/components/Sections/AdminNoticeSetting";
import { NormalSetting } from "pages/setting/components/Sections/NormalSetting";
import { BaseContainer, PageTitle } from "shared/ui/layout";

// 알림 설정(NotificationSetting)·개발 문의(InquirySetting)는 컴포넌트는 유지하되
// 설정 페이지에서는 노출하지 않는다. 다시 보이려면 아래 import와 렌더를 복구하면 된다.
// import { NotificationSetting } from "pages/setting/components/Sections/NotificationSetting";
// import { InquirySetting } from "pages/setting/components/Sections/InquirySetting";

function Setting() {
  return (
    <BaseContainer>
      <PageTitle pageName="설정" />
      <NormalSetting />
      <AdminNoticeSetting />
      {/* <NotificationSetting /> */}
      {/* <InquirySetting /> */}
    </BaseContainer>
  );
}

export default Setting;
